import React from 'react';

import type { FC } from 'react';

export const RemoveCircleFilled: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M10.0013 1.66797C5.4013 1.66797 1.66797 5.4013 1.66797 10.0013C1.66797 14.6013 5.4013 18.3346 10.0013 18.3346C14.6013 18.3346 18.3346 14.6013 18.3346 10.0013C18.3346 5.4013 14.6013 1.66797 10.0013 1.66797ZM13.3346 10.8346H6.66797C6.20964 10.8346 5.83464 10.4596 5.83464 10.0013C5.83464 9.54297 6.20964 9.16797 6.66797 9.16797H13.3346C13.793 9.16797 14.168 9.54297 14.168 10.0013C14.168 10.4596 13.793 10.8346 13.3346 10.8346Z" />
    </svg>
  );
};
